import React, {FC} from "react";
import {Grid, IconButton, ListItem, ListItemSecondaryAction, ListItemText} from "@material-ui/core";
import {EditOutlined as EditIcon} from "@material-ui/icons";
import {useServices} from "../redux/services.hook";
import {Skeleton} from "@material-ui/lab";
import _ from 'lodash';
import {ServiceListItem} from "./ServiceListItem";

const LoadingServiceListItem: FC = () => (
    <ListItem divider style={{minHeight: 60}}>
        <ListItemText>
            <Skeleton width={_.random(80, 150)}/>
        </ListItemText>
        <ListItemSecondaryAction>
            <IconButton
                edge="end"
                disabled
            >
                <EditIcon/>
            </IconButton>
        </ListItemSecondaryAction>
    </ListItem>
);

const renderLoadingListItems = () => [...Array(4)].map((_v, i) => <LoadingServiceListItem key={'loading-item-' + i}/>)

export const ServicesList: FC = () => {
    const services = useServices();

    return (
        <Grid container spacing={3}>
            {services.length === 0
                ? renderLoadingListItems()
                : services.map((service, sId) => (
                    <ServiceListItem
                        key={'service-' + service.id}
                        service={service}
                        isLast={sId === services.length - 1}
                    />
                ))
            }
        </Grid>
    )
}
